import { render, staticRenderFns } from "./CommissionsNotice.vue?vue&type=template&id=3f1ad7e9"
import script from "./CommissionsNotice.vue?vue&type=script&lang=js"
export * from "./CommissionsNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports